import { render, staticRenderFns } from "./DISCOBJECT.picker.component.vue?vue&type=template&id=4bcf18e4&"
import script from "./DISCOBJECT.picker.component.vue?vue&type=script&lang=js&"
export * from "./DISCOBJECT.picker.component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports